module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fits_images":"FITS Image"},"ja":{"fits_images":"FITS画像"}}')
  delete Component.options._Ctor
}
